<template>
  <nav class="footer__nav">
    <ul class="footer__nav-list list-reset">
      <li v-if="$route.name === 'main'" class="footer__nav-item">
        <router-link :to="{ name: 'main', hash: '#header' }" class="footer__nav-link link-reset"> В начало </router-link>
      </li>
      <li v-else class="footer__nav-item">
        <router-link :to="{ name: 'main' }" class="footer__nav-link link-reset">Главная</router-link>
      </li>
      <li class="footer__nav-item">
        <a href="/contract-offer.pdf" target="_blank" class="footer__nav-link link-reset">Договор-оферта</a>
      </li>
      <li class="footer__nav-item" v-for="link in links" :key="link.title">
        <router-link :to="{ name: link.page, hash: link.hash }" class="footer__nav-link link-reset">{{ link.title }}</router-link>
      </li>
    </ul>
  </nav>
</template>

<style scoped>
.footer__nav-list {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.footer__nav-item:not(:last-child) {
  margin-bottom: 10px;
}

.footer__nav-link {
  font-size: 16px;
  color: var(--white);
  transition: color 0.2s linear;
}

.footer__nav-link:hover:not(:active) {
  color: var(--main);
}

.footer__nav-link:active {
  color: var(--main-active);
}

.footer__nav-link:focus-visible:not(:active) {
  color: var(--main-hover);
}

@media (max-width: 1160px) {
  .footer__nav-item:not(:last-child) {
    margin-bottom: 0;
  }
}

@media (max-width: 769px) {
  .footer__nav-item:not(:last-child) {
    margin-bottom: 10px;
  }
}

@media (max-width: 600px) {
  .footer__nav-list {
    align-items: flex-start;
  }
}
</style>

<script>
export default {
  data () {
    return {
      links: [
        {
          title: 'О нас',
          page: 'main',
          hash: '#about'
        },
        {
          title: 'Суть программы',
          page: 'main',
          hash: '#desc'
        },
        {
          title: 'Преимущества',
          page: 'main',
          hash: '#advantage'
        },
        {
          title: 'Материалы',
          page: 'main',
          hash: '#materials'
        },
        {
          title: 'Калькулятор',
          page: 'main',
          hash: '#calculator'
        },
        {
          title: 'Регистрация',
          page: 'register',
          hash: ''
        },
        {
          title: 'Личный кабинет',
          page: 'personal',
          hash: ''
        }
      ]
    }
  }
}
</script>
